import { ServiceLandingEnum } from '@rover/types/src/ServiceLanding';

export const SERVICE_SEARCH_FORM_SUBMIT_TYPES = {
  SEARCH: 'search',
  DOG_BOARDING: 'dogBoarding',
  PET_SITTERS: 'petSitters',
  HOUSE_SITTERS: 'houseSitters',
  DAY_CARE: 'dayCare',
  DOG_WALKERS: 'dogWalkers',
} as const;

// Every service-landing type gets a search-results carousel except dog-training and puppy-training
export const SERVICE_LANDINGS_WITH_SEARCH_RESULTS: ServiceLandingEnum[] = [
  ServiceLandingEnum.CAT_BOARDING,
  ServiceLandingEnum.CAT_SITTING,
  ServiceLandingEnum.DOG_BOARDING,
  ServiceLandingEnum.DOG_KENNEL_ALTERNATIVE,
  ServiceLandingEnum.DOG_WALKING,
  ServiceLandingEnum.DOGGY_DAY_CARE,
  ServiceLandingEnum.HOUSE_SITTING,
  ServiceLandingEnum.LONG_TERM_DOG_BOARDING,
  ServiceLandingEnum.OVERNIGHT_DOG_BOARDING,
  ServiceLandingEnum.PET_SITTING,
  ServiceLandingEnum.PUPPY_BOARDING,
];
